import React, {FC, useState} from "react";
import brandLogo from "assets/media/brands/logo.svg";
import { Link, useHistory } from "react-router-dom";
import {notification, Form, Input, Modal} from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import {useAppDispatch} from "../../../redux/hooks";
import {loginFailure, loginRequest, loginSuccess} from "../../../redux/authSlice";
import userApi from "../../../services/api/UserApi";
import { hideLoading, showLoading } from "redux/commonSlice";
import './login.css'
import SystemApi from "../../../services/api/SystemApi";
// import {autoLogout} from "../../../redux/systemSlice";

interface LoginProps {}

const Login: FC<LoginProps> = () => {
	const history = useHistory()
	const dispatch = useAppDispatch()
	type ValidateStatus = Parameters<typeof Form.Item>[0]['validateStatus'];

	const [userName, setUserName] = useState(null);
	const [password, setPassword] = useState(null);
	const [firstChange, setFirstChange] = useState(false);
	const [validateType, setValidateType] = useState('onBlur')
	const [input, setInput] = useState<{
		value: string;
		validateStatus?: ValidateStatus;
		errorMessage?: string | null;
	}>({
		value: '',
	});
	const [errors, setErrors] = useState({ username: false, password: false});

	const getSystemConfigLogout = async () => {
		try {
			const res = await SystemApi.getSystemConfigLogOut();
			// server đang cấu hình phút (5p*60s*1000ms)
			// const timeOut = (Number(res?.data?.data?.value) * 60 * 1000);
			// await dispatch(autoLogout(timeOut));
		} catch (err: any) {
			console.log(err)
			Modal.error({title: err?.response?.data?.message});
		}
	}

	const handleLogin = async (e) => {
		dispatch(loginRequest());
		try {
			dispatch(showLoading({}))
			const res = await userApi.login(userName, password)
			dispatch(loginSuccess(res.data));
			if(res) {
				history.push("/data-transmission");
				notification.success({message: 'Đăng nhập thành công', duration: 3});
				await getSystemConfigLogout();
			}
			dispatch(hideLoading());
		} catch (err: any) {
			dispatch(hideLoading());
			dispatch(loginFailure());
			handleError(err);
		}

	}

	const handleError = (err) => {
		const errCode = err?.response?.data?.code
		if(err?.response?.status!= 405) {
			if(errCode === '99' || errCode === '29') {
				Modal.error({title: 'Thông tin đăng nhập không chính xác, vui lòng thử lại'})
			} else if (errCode === '30') {
				Modal.error({title: 'Tài khoản đã bị khóa do nhập sai mật khẩu quá số lần quy định, vui lòng liên hệ admin để mở khóa'})
			} else if(errCode === '31') {
				Modal.error({title: `Bạn đã đăng nhập vượt quá số lượng truy cập tối đa của 1 user là ${err?.response?.data?.data}`})
			} else if(err?.response?.data?.data?.[0]?.name ==='username') {
				Modal.error({title: 'Thông tin đăng nhập không chính xác, vui lòng thử lại'})
			} else {
				Modal.error({title: err?.response?.data?.message})
			}
		} else {
			Modal.error({title: 'Tài khoản không hợp lệ, vui lòng thử lại.'})

		}
	}
	const onChangeUserName = (value) => {
		if(firstChange){
			setErrors({...errors, username: true});
		}
		setUserName(value.target.value)
	}

	const onChangePassword = (value) => {
		if(firstChange){
			setErrors({...errors, password: true});
		}
		setPassword(value.target.value)
	};

	const handleBlur = (e: any) => {
		if(!firstChange){
			setFirstChange(true);
		}
		setErrors({...errors,[e.target.name]: true});
	};

	return (
		<>
			{/*<Spin spinning={isLoading} size="large"></Spin>*/}
			<div className="d-flex w-100 align-items-center position-relative overflow-hidden login-background-sub">
				<div className="login-wrapper">
					<div className="login-title h1 b mb-32">
						<img src={brandLogo} width="200" alt="" />
					</div>
					<div className="box login-box">
						<div className="form">
							<div className="h2 font-weight-500 mb-4 text-center ff-fantasy">
								VNPAY PORTAL INVOICE
							</div>
							<div
								className="fz-h4 text-primary mb-4 text-center"
							>
								Đăng nhập
							</div>
							<Form
								initialValues={{ remember: true }}
								onFinish={handleLogin}
								autoComplete="off"
							>
								<div className="form-login-inner list-mb20 list-crop">
									<div className="form-group">
										<label>
											<span className="text-danger">
												*
											</span>
											Tên đăng nhập
										</label>
										<Form.Item
											name="username"
											validateTrigger={validateType}
											rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập'}, {pattern: /^[A-Za-z0-9-_@./#&+-]*$/, message: 'Chỉ cho phép nhập ký tự không dấu, ký tự đặc biệt, chữ, số, không khoảng trắng, viết liền, không phân biệt hoa thường'}]}
										>
											<Input
												minLength={1}
												maxLength={50}
												onChange={onChangeUserName}
												value={input.value}
												placeholder="Nhập tên đăng nhập"
												className="form-control form-control-lg"
												type="text"
												// onBlur={handleBlur}
												onBlur={() => setValidateType('onChange')}
											/>
										</Form.Item>
									</div>
									<div className="form-group">
										<label>
											<span className="text-danger">
												*
											</span>
											Mật khẩu
										</label>

										<Form.Item
											name="password"
											validateTrigger={validateType}
											rules={[
												{ required: true, message: 'Vui lòng nhập mật khẩu'}, {pattern: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&^()#_+=])([a-zA-Z0-9@$!%*?&^()#_+=]{8,})$/, message: 'Mật khẩu phải có tối thiểu 8 ký tự và chứa ít nhất 1 ký tự số, 1 chữ thường, 1 chữ hoa, 1 ký tự đặc biệt và không khoảng trắng'}]}
										>
											<Input.Password
												minLength={1}
												maxLength={20}
												value={input.value}
												onChange={onChangePassword}
												className="form-control form-control-lg"
												placeholder="Nhập mật khẩu"
												onBlur={() => setValidateType('onChange')}
												iconRender={(visible) =>
													visible ? (
														<EyeTwoTone />
													) : (
														<EyeInvisibleOutlined />
													)
												}
											/>
										</Form.Item>
									</div>
									<Form.Item>
										<button className="btn btn-info btn-block btn-lg">
											Đăng nhập
										</button>
									</Form.Item>
									<div className="text-center">
										<Link
											to={"/auth/forgot-password"}
											className="link text-forgot"
										>
											Quên mật khẩu?
										</Link>
									</div>
								</div>
							</Form>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Login;
